import Banner from "./components/Banner/Banner";
import BuyItWeDeliverItSingle from "./components/BuyItWeDeliverItSingle/BuyItWeDeliverItSingle";
import MakeCars from "./components/MakeCars/MakeCars";
import List from "./components/List/List";
import CarsFinance from "./components/CarsFinance/CarsFinance";
import stl from "./SingleCityComponent.module.css";
import LatestOffer from "../Cities/components/LatestOffer/LatestOffer";
import {useTranslation} from "@i18n";

const SingleCityComponent = ({
  cityDetails,
  cityName
}) => {
  const {t} = useTranslation(["web_city"]);
  return (
    <>
      <div>
        <Banner cityName={cityName} />
        <div className={stl.SC_container}>
          {cityDetails?.posts && (
            <LatestOffer posts={cityDetails?.posts} />
          )}

          <BuyItWeDeliverItSingle cityName={cityName} />
          {cityDetails?.makes && (
            <MakeCars makes={cityDetails?.makes} cityName={cityName} />
          )}

          <CarsFinance cityName={cityName} />

          {cityDetails?.cities && (
            <List
              title={t("بنوصلك السيارة إلى كافة المحافظات السعودية", {
                ns: "web_city",
              })}
              list={Object.values(cityDetails?.cities).filter((city) => city.name !== cityName)
                .slice(0, 8)}
              name={cityName}
              buttonText={t("جميع المدن", {
                ns: "web_city",
              })}
              buttonUrl="/city"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SingleCityComponent;
